import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchDeck } from "@/lib/api";
import { START_METERS, applyEffects, checkEnd, computeScore, getTitleKey, saveBest } from "@/lib/engine";

export const useGame = () => {
  const navigate = useNavigate();
  const [deck, setDeck] = useState(null);
  const [idx, setIdx] = useState(0);
  const [meters, setMeters] = useState(START_METERS);
  const [turn, setTurn] = useState(0);
  const [deltas, setDeltas] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchDeck().then(setDeck);
  }, []);

  const card = deck ? deck[idx % deck.length] : null;

  const choose = (side) => {
    if (!card) return;
    const effects = card[side].effects;
    const next = applyEffects(meters, effects);
    const nextTurn = turn + 1;
    const hist = [...history, { id: card.id, side, topic: card.topic }];
    setMeters(next);
    setTurn(nextTurn);
    setHistory(hist);
    setDeltas(effects);
    setTimeout(() => setDeltas(null), 1100);
    const end = checkEnd(next, nextTurn);
    if (!end.over) {
      setIdx((i) => i + 1);
      return;
    }
    const score = computeScore(next, nextTurn, end.survived);
    saveBest(score);
    const state = { meters: next, turn: nextTurn, reason: end.reason, survived: end.survived, score, titleKey: getTitleKey(end.reason, next), history: hist };
    setTimeout(() => navigate("/result", { state }), 500);
  };

  return { card, meters, turn, deltas, choose };
};
